'use client';

// The brand slogan "Put your money where your mouth is.", rendered as the
// lead-in above the How-it-works heading so the punchline connects directly
// into the explanation of the product rather than floating as its own section.
// Landing is English-only (MOR-693); the namespace resolves via the landing's
// NextIntlClientProvider.

import { useTranslations } from 'next-intl';
import type { JSX } from 'react';

import { LandingSectionReveal } from '@/components/support-mainnet/landing-section-reveal';

export function HowItWorksSlogan(): JSX.Element {
  const t = useTranslations('supportMainnet.slogan');

  return (
    <LandingSectionReveal className="mx-auto flex max-w-3xl flex-col items-center px-4">
      <p className="text-balance text-center text-display-lg leading-[1.05] tracking-[-0.02em] text-foreground-primary md:text-display-xl">
        {t('line1')} <span className="text-foreground-brand">{t('line2')}</span>
      </p>
    </LandingSectionReveal>
  );
}
